import versionData from '#version.json';
export function getVersion() {
    const major = versionData.version.major;
    const minor = versionData.version.minor;
    const build = Number(versionData.version.build);
    return {
        major,
        minor,
        build,
    };
}
export function getVersionString() {
    const major = versionData.version.major;
    const minor = versionData.version.minor;
    const build = Number(versionData.version.build);
    return `${major}.${minor}.${build}`;
}
